module.exports = __webpack_public_path__ + "f975ef17918f5c826724045e1a8a8d1d.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-24@2x.png
// module id = 508
// module chunks = 0